var map = {
	"./1.png": "775a",
	"./2.png": "8e30",
	"./3.png": "1f66",
	"./app_h.png": "954b",
	"./app_y.png": "e843",
	"./bg-play.png": "af71",
	"./cityapp-logo.png": "7868",
	"./cityapp/background-2.png": "3fcd",
	"./cityapp/background.png": "6511",
	"./cityapp/logo.png": "13c5",
	"./cityapp/phone.png": "367e",
	"./cityapp/slogan-2.png": "71f4",
	"./cityapp/slogan.png": "ba96",
	"./h5.png": "c52f",
	"./h5_detail.png": "e53a",
	"./icon_android.png": "36cb",
	"./icon_iphone.png": "4e8b",
	"./logo_58.png": "cd73",
	"./new_1.png": "35cf",
	"./new_2.png": "c68b",
	"./new_3.png": "0b54",
	"./new_4.png": "2cec",
	"./new_5.png": "9d80",
	"./new_6.png": "bf70",
	"./play.png": "d99c",
	"./sy_1.png": "89cc",
	"./sy_2.png": "ede6",
	"./sy_3.png": "3b0d",
	"./sy_4.png": "1faf",
	"./sy_5.png": "1ff4",
	"./wechat-play.png": "47dc",
	"./网络文化经营许可证.png": "a963"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";